import { isValidElement } from 'react';

const getDisplayName = child => {
  if (! /*#__PURE__*/isValidElement(child)) {
    return "";
  }
  if (typeof child.type === "string") {
    return child.type;
  }
  return child.type.displayName ?? "";
};
const matchesDisplayName = (Components, child) => Components.some(c => c.displayName === getDisplayName(child));

export { getDisplayName, matchesDisplayName };
